import type { FaireProductEntity } from "../../entity_types/product";

export const p_58orev4h: FaireProductEntity = {
  token: "p_58orev4h",
  type: "product",
  name: "Mini Energy Gem - Black Tourmaline - Gold Earrings",
  brandToken: "b_f0fbd5c7",
  brandName: "JaxKelly",
  imageUrl:
    "https://cdn.faire.com/fastly/e455a46c2449edcdbd9c4a8ef92f658f5c6f2c68a228299896283b2b48d8db6c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0e30d12a7b71c66a1896a5d4ab5fa501ab36d0228f82957dbcf436e75cded0a5.jpeg",
    "https://cdn.faire.com/fastly/8eef868319e1c3614b57b63ed6f962e02ec1abe8ac2af9d45effc7aa94f8c7eb.jpeg",
    "https://cdn.faire.com/fastly/8859956e8e45c2b198df8ecd1dddd47e8200917d56a1c42fbe3bd7dab0bcd1b6.jpeg",
    "https://cdn.faire.com/fastly/e0cbff858a949c69ffa2a69814086bf9c1668095b8a95db0376d758990876be8.jpeg",
    "https://cdn.faire.com/fastly/bfe9fdebf433d4d3f029f0f146e79901fe9f29aa1da61e8c38b8668be0183ff5.jpeg",
    "https://cdn.faire.com/fastly/0350c62a8c00b547d554eba7f2dde127314c80cd9189f50d56e1886db2b0e389.jpeg",
  ],
  priceDollars: 17.3,
  description:
    "Our Mini Energy Gem studs feature a triangular stone set in a prong.\n\n• Tarnish Free - Long lasting protective coating safeguarding your jewelry from sweat, water, and more.\n• Sterling Silver – 18K gold plating over silver\n• Hypoallergenic – Lead Free\n• Black Tourmaline Gemstone\n• Height 5mm",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:27.618Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
